var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3448 3416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M905.067 711.667H3017L2729.67 1708H1059.79M2873.33 2277.33H1149.33L862 427H431M1293 2846.67C1293 2925.28 1228.68 2989 1149.33 2989C1069.99 2989 1005.67 2925.28 1005.67 2846.67C1005.67 2768.06 1069.99 2704.33 1149.33 2704.33C1228.68 2704.33 1293 2768.06 1293 2846.67ZM2873.33 2846.67C2873.33 2925.28 2809.01 2989 2729.67 2989C2650.32 2989 2586 2925.28 2586 2846.67C2586 2768.06 2650.32 2704.33 2729.67 2704.33C2809.01 2704.33 2873.33 2768.06 2873.33 2846.67Z",
    stroke: "white",
    strokeWidth: 174,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCart);
export default __webpack_public_path__ + "static/media/add-to-cart.d78d28731fd8954db361ed930f1f31f5.svg";
export { ForwardRef as ReactComponent };